import { ClassFormPage } from './ClassFormPage';
export default ClassFormPage;
